import axios from 'axios';
import { z } from 'zod';

import { SERVICEBASEURL } from 'enums/serviceBaseUrls';
import { Optional } from 'functions/promiseExtensions';
import { createValidator } from 'functions/validation/zod';
import EntityType from 'types/ShoppingCart/EntityType';

const TranslationsSchema = z.record(z.string());

const AppearanceSchema = z.object({
	entityId: z.string().uuid(),
	entityType: z.enum([
		EntityType.MENU,
		EntityType.RECIPE,
		EntityType.MENUPLAN,
		EntityType.USERCHANGE,
	]),
	nameTranslation: TranslationsSchema,
	quantity: z.number(),
});

const SourceSchema: z.ZodSchema = z.lazy(() =>
	z.object({
		id: z.string().uuid(),
		type: z.enum([
			EntityType.MENU,
			EntityType.RECIPE,
			EntityType.MENUPLAN,
			EntityType.USERCHANGE,
		]),
		nameTranslation: TranslationsSchema,
		childSource: SourceSchema.nullable(),
	})
);

const ProductItemSchema = z.object({
	productId: z.string(),
	ingredientId: z.string().uuid(),
	store: z.string(),
	weightOrVolume: z.number(),
	isFluid: z.boolean(),
	source: SourceSchema,
	ingredientNameTranslation: TranslationsSchema,
});

const ResponseDataSchema = z.object({
	appearances: z.array(AppearanceSchema),
	productItems: z.array(ProductItemSchema),
});

export type ProductItems = z.infer<typeof ProductItemSchema>;
export type ResponseData = z.infer<typeof ResponseDataSchema>;
const validator = createValidator(ResponseDataSchema);

export type RequestBody = {
	appearances: {
		entityId: string;
		entityType: string;
		quantity: number;
	}[];
};

export async function callApi(id: string, request: RequestBody): Promise<Optional<ResponseData>> {
	const url: string = `${SERVICEBASEURL.BACKEND}/ShoppingCart/UpdateAppearances/` + id;
	return (await axios.put(url, request).toOptionalFiltered(validator)).map((x) => x.data);
}
